import React, { useState } from 'react';
import classNames from 'classnames';
import { connect } from "react-redux";
import { Modal  } from 'antd';
import Button from "components/button";
import { 
	doFinalPayProgressUpdate
} from "../../../../redux/finalpay/finalPayState";

function FinalPayProcessButton({doFinalPayProcess, finalPayId, process, children, confirmationMessage, className, ...rest}) {
	
	const buttonClassName = classNames('me-3',className);
	const [open, setOpen] = useState(false);
	
	const processHandler = () => {		
		doFinalPayProcess({finalPayId, process});
        setOpen(false);
	};
	
    return (<>
    	<Button className={buttonClassName.trim()} 
    		{...rest}
    		onClick={(e) => {e.preventDefault();setOpen(true)}}
		>
  			{children}
		</Button> 
		<Modal
            open={open}
            closeIcon={false}
            centered
            title="Confirm Action"
            okText="Confirm"
            cancelText="Cancel"
            footer={(_) => (
                <>
                    <Button className="me-4" 
                        onClick={() => {setOpen(false)}}
                    >
                        Cancel
                    </Button>
                    <Button className="btn-primary" 
                        onClick={processHandler}
                    >
                        Confirm
                    </Button>
                </>
            )}
        >
        	{confirmationMessage && <div>{confirmationMessage}</div>}            
            <div>Are you sure you want to continue?</div>
        </Modal>
    </>);
}

const mapStateToProps = () => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  doFinalPayProcess: (parameters) => dispatch(doFinalPayProgressUpdate(parameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPayProcessButton);



